
import { useState, useEffect } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Music } from "lucide-react";

// Sound options with only the working meditation sound
const SOUND_OPTIONS = [
  {
    id: 'meditation',
    name: 'Meditation',
    url: 'https://assets.mixkit.co/active_storage/sfx/2434/2434-preview.mp3',
    attribution: 'Meditation Sound from Mixkit'
  }
];

// Export sound options for access in other components
export { SOUND_OPTIONS };

interface SoundSelectorProps {
  onSoundSelect: (url: string) => void;
  selectedSound: string;
}

export const SoundSelector = ({ onSoundSelect, selectedSound }: SoundSelectorProps) => {
  const [selectedName, setSelectedName] = useState('Meditation');

  // Update selected name when selectedSound changes
  useEffect(() => {
    if (selectedSound) {
      const selected = SOUND_OPTIONS.find(s => s.url === selectedSound);
      if (selected) {
        setSelectedName(selected.name);
      }
    } else {
      setSelectedName('Meditation');
    }
  }, [selectedSound]);

  const handleSoundSelect = (sound: typeof SOUND_OPTIONS[0]) => {
    console.log("Selected sound:", sound.name, sound.url);
    onSoundSelect(sound.url);
    setSelectedName(sound.name);
  };

  return (
    <div className="flex items-center">
      <Button 
        variant="outline" 
        size="sm" 
        className="flex items-center gap-1 bg-background h-7 px-2 py-0 text-xs"
        onClick={() => handleSoundSelect(SOUND_OPTIONS[0])}
      >
        <Music className="h-3 w-3" />
        <span className="text-xs max-w-20 truncate">Meditation</span>
      </Button>
    </div>
  );
};
